var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-text-field',{attrs:{"value":_vm.value,"label":"Template title"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }